import Modal, { CloseButton, DialogTitle, BackButton } from '../../../../../components/Modal'
import React from 'react'
import ProductListView, { EditProduct } from './ProductListView'
import { Box, Stack, Theme, useMediaQuery } from '@mui/material'
import Typography from '../../../../../components/Typography'
import MaterialSymbol from '../../../../../components/MaterialSymbol'
import ProductListFilter, { filterReducer } from './ProductListFilter'
import { SortingOptions } from '../../../../../util/consts'
import EditProductView from './EditProductView'
import { CartItem } from '../../../../cart/storage/cart.types'
import TestIds from '../../../../../testIds'

interface QuoteAddProductModalProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  onAddProduct: (product: CartItem) => void
}

const closeBtnId = TestIds.feat.quotes.details.addProductModal.closeBtn

const QuoteAddProductModal: React.FC<QuoteAddProductModalProps> = ({
  open,
  setOpen,
  onAddProduct,
}) => {
  const [editProduct, setEditProduct] = React.useState<EditProduct>()
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  const [filterState, setFilterState] = React.useReducer(filterReducer, {
    searchText: undefined,
    sortBy: SortingOptions.BestMatch,
    currentPage: 1,
    category: undefined,
  })

  function handleAddProduct(product: CartItem) {
    onAddProduct(product)
    handleCloseModal()
  }

  function handleEditProduct(product: EditProduct) {
    setEditProduct(product)
  }

  function handleCloseModal() {
    setOpen(false)
    setEditProduct(undefined)
    setFilterState({ searchText: undefined, category: undefined })
  }

  return (
    <Modal
      open={open}
      handleClose={handleCloseModal}
      maxWidth='md'
      paperProps={{
        sx: { height: isSm ? 'inherit' : '844px', overflow: 'hidden' },
      }}
      customHeader={
        editProduct ? (
          <Stack direction='row' justifyContent='space-between'>
            <BackButton onClick={() => setEditProduct(undefined)}>
              <MaterialSymbol>arrow_back</MaterialSymbol>
              <Typography variant='body2'>Back</Typography>
            </BackButton>
            <CloseButton
              id={closeBtnId}
              data-testid={closeBtnId}
              variant='outlined'
              disableTouchRipple
              onClick={handleCloseModal}
            >
              <Typography variant='body2'>Close</Typography>
              <MaterialSymbol>close</MaterialSymbol>
            </CloseButton>
          </Stack>
        ) : (
          <>
            <DialogTitle>
              Add Products
              <CloseButton
                id={closeBtnId}
                data-testid={closeBtnId}
                variant='outlined'
                disableTouchRipple
                onClick={handleCloseModal}
              >
                <Typography variant='body2'>Close</Typography>
                <MaterialSymbol>close</MaterialSymbol>
              </CloseButton>
            </DialogTitle>
            <ProductListFilter filter={filterState} setFilter={setFilterState} />
          </>
        )
      }
    >
      <>
        <Box sx={{ display: editProduct ? 'none' : 'block' }}>
          <ProductListView
            filterState={filterState}
            setFilterState={setFilterState}
            onAddProduct={handleAddProduct}
            onEditProduct={handleEditProduct}
          />
        </Box>
        {editProduct ? <EditProductView {...editProduct} onAddProduct={handleAddProduct} /> : null}
      </>
    </Modal>
  )
}
export default QuoteAddProductModal
